export const HOMETREE_PMT_OPTION_SETUP_EXTERNAL_ID = 'hometree_integration_setup'